export default __webpack_public_path__ + "static/media/logo.be1ac949.png";